<template>
  <div class="bodycontent">
    <div class="page_title">
      亲属卡设置
    </div>
    <div class="page_form">
      <!-- <div class="open_box">
        <div class="open_label">开启亲属卡</div>
        <div><el-switch v-model="open" active-color="#13ce66"></el-switch></div>
      </div> -->
      <el-form :model="formData" size="small" label-width="120px">
        <el-form-item label="积分归集">
          <el-radio-group v-model="formData.point">
            <el-radio :label="1">总账户</el-radio>
            <el-radio :label="2">子账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠券归集">
          <el-radio-group v-model="formData.coupon">
            <el-radio :label="1">总账户</el-radio>
            <el-radio :label="2">子账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="余额归集">
          <el-radio-group v-model="formData.balance">
            <el-radio :label="1">总账户</el-radio>
            <el-radio :label="2">子账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分配最大额度">
          <el-input class="input_box" v-model="formData.max_quota"></el-input>元
        </el-form-item>
        <el-form-item label="手机号验证" v-if="false">
          <el-radio-group v-model="formData.verify_mobile">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div class="form_info_text">子账户付款时是否需要获取主账户手机号</div>
        </el-form-item>
        <el-form-item label="最大关系数">
          <el-input-number style="width:90px" :min="1" v-model="formData.max_num" controls-position="right" :disabled="unlimited"></el-input-number>
          <el-checkbox label="无限制" border v-model="unlimited" style="margin-left:9px;vertical-align: middle;"></el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { getFamily, setFamily } from '@/api/set';
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      formData:{},
      unlimited: true,  //最大关系数是否无限制
      open: false, // 是否开启亲属卡
    }
  },
  mounted(){
    this.init();
  },
  methods:{
    init(){
      var data = {
        token: this.token,
        app_id: this.app_id
      }
      getFamily(data).then(res => {
        if(res.code == 200){
          console.log(res.data)
          this.formData = Object.assign({},res.data);
          this.unlimited = this.formData.max_num == 0? true:false;
          delete this.formData.id;
          delete this.formData.create_time;
          delete this.formData.update_time;
        }else{
          this.$message(res.msg);
        }
      })
    },
    save(){
      var data = Object.assign({},this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      data.max_num = this.unlimited? "0":data.max_num;
      console.log(data);
      setFamily(data).then(res => {
        if(res.code == 200){
          this.$message({
            type: "success",
            message: "保存成功"
          })
          this.init();
        }else{
          this.$message(res.msg);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding:0 18px;
  .page_title{
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form{
    padding-top: 30px;
    .input_box{
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small{
      width: 50px;
    }
    .form_info_text{
      color: #aaa;
    }
  }
  .save_button{
    margin-top: 25px;
    padding-left:100px;
    margin-bottom: 50px;
    
  }
  .open_box{
    display: flex;
    height: 32px;
    line-height: 32px;
    margin-bottom: 18px;
    .open_label{
      width: 120px;
      padding-right:12px;
      color: #606266;
      font-size: 14px;
      text-align: right;
    }
  }
}
</style>